export { default } from './SyndicatedStoryModal';
export { default as reducer } from './SyndicatedStoryModal.ducks';
export { default as sagas } from './SyndicatedStoryModal.sagas';

import * as actions from './SyndicatedStoryModal.ducks';
export { actions };

